import { Button, Form } from 'antd'
import React from 'react'
import ProductData from '../../../Data/Products.json'
import { cn } from '../../../utils/cn'
import { RiRecordCircleFill } from "react-icons/ri";
import { motion } from 'motion/react';
import { useNavigate } from 'react-router-dom';
import { BsPinAngleFill } from 'react-icons/bs';


function Products({ form }) {


    const navigate = useNavigate()





    return (
        <div id='product' className='w-full'>
            <div className='w-full container mx-auto py-10 p-5 md:px-0 h-min flex items-center'>
                <div className='w-full grid grid-cols-1 md:grid-cols-4 gap-5 mt-5'>

                    {
                        ProductData.map((product, index) => (
                            <motion.div
                                initial={{ opacity: 0, y: 100 }}
                                animate={{ opacity: 1, y: 0 }}
                                transition={{ duration: 0.5 }}

                                className={cn('w-full border-4  shadow-xl p-10 rounded-xl justify-between flex flex-col items-center min-h-[400px] gap-5', {
                                    'border-t-yellow-500': product.category,
                                    'border-t-blue-500': !product.category
                                })}>
                                <img src={product.img} alt={product.name} className='w-20 h-20 object-cover' />
                                <h3 className='text-3xl font-normal text-center'>
                                    {product.name}
                                </h3>
                                <p className='text-base text-gray-500 text-center'>
                                    {product.subtitle}
                                </p>
                                <ul className='font-semibold text-sm self-start flex flex-col gap-4'>
                                    {
                                        product.items.map((feature, index) => (
                                            <div className='flex gap-2 items-center'>
                                                <BsPinAngleFill className='text-red-500' size={20} />
                                                <li key={index} className='flex gap-2 w-[90%]'>
                                                    {feature}
                                                </li>
                                            </div>
                                        ))
                                    }
                                </ul>
                                <div className='border-2 border-blue-500 p-5 w-[60%] flex flex-col gap-3 items-center'>
                                    <RiRecordCircleFill className='text-blue-500 text-4xl' />
                                    <p className='font-bold text-sm'>
                                        Mes
                                    </p>
                                    <p className='text-2xl font-bold'>
                                        {product.price} UF
                                    </p>
                                </div>
                                <p className='text-gray-500'>
                                    *Valor no incluye IVA<br />
                                    Planes son a 12 meses
                                </p>
                                <Button
                                    onClick={() => navigate(`/product/${product.url}`)}
                                    className='bg-red-700 text-2xl py-7 text-white w-full rounded-full'>
                                    Contáctanos
                                </Button>
                            </motion.div>
                        ))
                    }
                </div>
            </div>
        </div>
    )
}

export default Products